import { render, staticRenderFns } from "./proxyBalanceList.vue?vue&type=template&id=95236578&scoped=true"
import script from "./proxyBalanceList.vue?vue&type=script&lang=js"
export * from "./proxyBalanceList.vue?vue&type=script&lang=js"
import style0 from "./proxyBalanceList.vue?vue&type=style&index=0&id=95236578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95236578",
  null
  
)

export default component.exports